import { createFileRoute } from '@tanstack/react-router'
import { BrandAccessPage } from '@/features/account/pages/brands/brand-access-page'

export interface BrandAccessSearch {
  addPeople?: boolean
}

/** E4 — Brand access (roster gap-blocked; chrome + states + note). */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands/$brandId/access')({
  validateSearch: (search: Record<string, unknown>): BrandAccessSearch => ({
    addPeople:
      search.addPeople === true || search.addPeople === 'true' ? true : undefined,
  }),
  component: BrandAccessPage,
})
